import { ArticleCards } from "./article-cards/index.js"
import { CTALeftImageRight } from "./cta-left-image-right/index.js"
import { ImageLeftCTARight } from "./image-left-cta-right/index.js"
import { LargeCTA } from "./large-cta/index.js"
import { SingleColumn } from "./single-column/index.js"
import { TwoColumns } from "./two-columns/index.js"
import { TwoColumnsLargeCTA } from "./two-columns-large-cta/index.js"
import { ArticleListItem } from "./article-list-item/index.js"
import { SponsorCTALeftSmallImage } from "./sponsor-cta-left-small-image/index.js"
import { SmallCTA } from "./small-cta/index.js"
import { Testimonial } from "./testimonial/index.js"
import { PersonalSignature } from "./personal-signature/index.js"
import { StarTestimonial } from "./star-testimonial/index.js"
import { SponsorCTANoImage } from "./sponsor-cta-no-image/index.js"
import { CTALeftHeaderImageRight } from "./cta-left-header-image-right/index.js"
import { RoundImageLeftCopyRight } from "./round-image-left-copy-right/index"
import { Navigation } from "./navigation/index.js"
import { Quote } from "./quote/index"

export function applyThemeToPlaceholderValue(blocks, buttonTheme) {
  return blocks.map(block => {
    if (block.type !== "text") return block

    const { nodes } = block.properties.value.document

    const themedNodes = nodes.map(node => {
      if (node.type === "button") {
        return {
          ...node,
          data: { ...node.data, ...buttonTheme }
        }
      } else {
        return node
      }
    })

    block.properties.value.document.nodes = themedNodes

    return block
  })
}

// This array contains a configuration object for each layout "template" – for
// instance, "CTALeftImageRight" is a template with a CTA on the left and an
// image on the right. Each template has its own editor and settings components,
// and conventionally uses a descriptive name.

export const templates = [
  RoundImageLeftCopyRight,
  Navigation,
  CTALeftImageRight,
  ImageLeftCTARight,
  SingleColumn,
  TwoColumns,
  LargeCTA,
  ArticleCards,
  Testimonial,
  SponsorCTALeftSmallImage,
  SmallCTA,
  TwoColumnsLargeCTA,
  ArticleListItem,
  PersonalSignature,
  CTALeftHeaderImageRight,
  SponsorCTANoImage,
  StarTestimonial,
  Quote
]

